<template>
  <div>
    Đang xử lý
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { STORE_KEY } from '../_store/constants'

export default {
  name: 'ExamPurchaseConfirm',
  data() {
    return {
      id: this.$route.params.id,
      slug: this.$route.params.slug,
    }
  },
  computed: {
    ...mapGetters({
      exam: `${STORE_KEY}/exam`
    })
  },
  beforeMount() {
    this.getExamPurchase({ id: this.id, slug: this.slug });
  },
  mounted() {
    // this.$router.push({ name: 'user-detail'});
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ['getExamPurchase'])
  }
};
</script>